<script>
import { mapActions } from "vuex";
import InfiniteRecycleDisposerAutoComplete from "@/driver/components/InfiniteRecycleDisposerAutoComplete.vue";
import InfiniteTraderLocationAutoComplete from "@/driver/components/InfiniteTraderLocationAutoComplete.vue";
import ChooseTraderModal from "@/driver/components/ChooseTraderModal.vue";

export default {
	name: "ChooseRecycleDisposalPatternModal",
	components: {
		InfiniteTraderLocationAutoComplete,
		InfiniteRecycleDisposerAutoComplete,
		ChooseTraderModal,
	},
	props: {
		enable: {
			type: Boolean,
			default: false,
		},
		onlyMethod: {
			type: Boolean,
			default: false,
		},
		onlyFlow: {
			type: Boolean,
			default: false,
		},
		fixedCondition: {
			type: Object,
			default: null,
		},
    ownDisposer: {
      type: Boolean,
      default: false,
    },
		finalDisposal: {
			type: Boolean,
			default: null,
		},
	},
	data() {
		return {
			enableTraderModal: false,
			searchPanel: 0,
			conditions: {
				selectable_menu: "method",
				pattern_name: null,
				disposer_id: null,
        disposer_location_id: null,
        disposer_location_code: null,
        disposal_category_codes: [],
        disposal_subcategory_ids: [],
				recycle_disposal_method_name: null,
				after_disposal_method_ids: [],
				without_invisible: true,
        own_disposer: false,
				final_disposal: null,
			},
			methodPage: 1,
			methodPerPage: 50,
			methods: [],
			methodPagination: {
				current_page: 1,
				total_count: 0,
			},
			flowPage: 1,
			flowPerPage: 50,
			flows: [],
			flowPagination: {
				current_page: 1,
				total_count: 0,
			},
			selectedPattern: null,
			loading: false,
			afterRecycleMethods: [],
      afterDisposalItemCategories: [],
      afterDisposalItemSubcategories: [],
      selectableRow: null,
			listHeaders: [
        { value: "pattern_name", text: "コード\r\nパターン名\r\n処分前廃棄物種類", width: "20%" },
				{ value: "disposer", text: "処分事業者\r\n処分事業場\r\n住所", width: "23%" },
				{ value: "before_ratio", text: "按分割合\r\n処分方法", width: "25%" },
				{ value: 'output_type', text: "処理後割合\r\n処理後物の種類", width: "25%" },
			],
		};
	},
	computed: {
		dialogTitle() {
			if (this.onlyMethod) return "処分場処理方法を選択";
			if (this.onlyFlow) return "処理フローを選択";
			return "処分場処理方法・処理フローを選択";
		},
		isDisposerConditionFixed() {
			return this.effectiveFixedCondition.disposer_id != null
				&& this.effectiveFixedCondition.disposer_location_code != null;
		},
		isMethod() {
			return this.conditions.selectable_menu === "method";
		},
		displayedItems() {
			if (this.onlyMethod) {
				return this.methods;
			}
			if (this.onlyFlow) {
				return this.flows;
			}
			return this.isMethod ? this.methods : this.flows;
		},
		totalPages() {
			const source = this.onlyMethod || (!this.onlyFlow && this.isMethod) ? this.methodPagination : this.flowPagination;
			return source.total_pages || 0;
		},
		currentPage: {
			get() {
				if (this.onlyMethod) {
					return this.methodPage;
				}
				if (this.onlyFlow) {
					return this.flowPage;
				}
				return this.isMethod ? this.methodPage : this.flowPage;
			},
			set(value) {
				if (this.onlyMethod || (!this.onlyFlow && this.isMethod)) {
					this.methodPage = value;
				} else {
					this.flowPage = value;
				}
			},
		},
		selectedRowType() {
			if (this.onlyMethod) {
				return "methods";
			}
			if (this.onlyFlow) {
				return "flows";
			}
			return this.isMethod ? "methods" : "flows";
		},
		effectiveFixedCondition() {
			return this.fixedCondition || {};
		},
	},
	watch: {
		enable(value) {
      if (value) {
				this.initialize();
			}
		},
	},
	methods: {
		...mapActions("DriverMasterRecycleDisposerDisposalMethod", {
			fetchMethods: "index",
		}),
		...mapActions("DriverMasterRecycleDisposalFlow", {
			fetchFlows: "index",
		}),
		...mapActions("DriverMasterSearchAfterRecycleMethod", {
			fetchAfterRecycleMethods: "index"
		}),

    /**
     * 処理後物の大分類
     */
    ...mapActions("DriverMasterSearchRecycleDisposedItemCategory", {
      fetchItemCategories: 'index',
    }),

    ...mapActions("DriverMasterSearchRecycleDisposedItemSubcategory", {
      fetchItemSubcategories: 'index',
    }),

		patternNameChangedCallback(value) {
			this.conditions.pattern_name = value;
			this.searchButtonClickEvent();
		},

		recycleDisposalMethodNameChangedCallback(value) {
			this.conditions.recycle_disposal_method_name = value;
			this.searchButtonClickEvent();
		},

		afterDisposalMethodIdsChangedCallback(values) {
			this.conditions.after_disposal_method_ids = values;
			this.searchButtonClickEvent();
		},

		openChooseTraderModalClickEvent() {
			this.enableTraderModal = true;
		},

		initialize() {
      this.conditions.disposer_id = null;
      this.conditions.disposer_location_id = null;
      Object.assign(this.$data.conditions, this.$options.data().conditions);
      Object.assign(this.$data.methodPagination, this.$options.data().methodPagination);
      Object.assign(this.$data.flowPagination, this.$options.data().flowPagination);

      if (this.selectableRow) {
        this.selectableRow.select(false)
        this.selectableRow = null;
      }

      this.searchPanel = 0;
      this.conditions.selectable_menu = this.onlyFlow ? "flow" : "method";
      this.conditions.pattern_name = null;
      this.conditions.disposer_id = this.effectiveFixedCondition.disposer_id || null;
      this.conditions.disposer_location_id = this.effectiveFixedCondition.disposer_location_id || null;
      this.conditions.disposer_location_code = this.effectiveFixedCondition.disposer_location_code || null;
      this.conditions.after_disposal_item_category_name = [];
      this.conditions.after_disposal_item_subcategory_id = [];
      this.conditions.recycle_disposal_method_name = null;
      this.conditions.after_disposal_method_ids = [];
      this.conditions.without_invisible = true;
      this.conditions.own_disposer = this.ownDisposer;
			this.conditions.final_disposal = this.finalDisposal;
			this.methodPage = 1;
			this.flowPage = 1;
			this.methods = [];
			this.flows = [];
			this.selectedPattern = null;

      this.loadAfterDisposalOptions()

			this.search();
		},

		closeButtonClickEvent() {
			this.$emit("close");
		},

		registerButtonClickEvent() {
			if (!this.selectedPattern) {
				return;
			}
			this.$emit("selected", {
				pattern: this.selectedPattern,
				// pattern_details: this.patternDetails,
			});
		},

		menuChangeEvent() {
			this.currentPage = 1;
			this.selectedPattern = null;
			this.search();
		},

		searchButtonClickEvent() {
			this.currentPage = 1;
			this.selectedPattern = null;
			this.search();
			//this.searchPanel = undefined;

		},

		pageChangeEvent(page) {
			this.currentPage = page;
			this.search();
		},


    // 大分類の選択肢を取得し、続けて種類の選択肢も取得する
    loadAfterDisposalOptions () {
      this.fetchItemCategories({
        disable_pagination: true,
      }).then((content) => {
        this.afterDisposalItemCategories = content.after_disposal_items || []
        return this.loadDisposedTypeOptions()
      })
    },
    // 選択中の大分類に紐づく種類の選択肢を取得する（大分類未選択時はクリア）
    loadDisposedTypeOptions () {
      if (this.conditions.disposal_category_codes.length <= 0) {
        this.afterDisposalItemSubcategories = []
        this.conditions.disposal_subcategory_ids = []
        return Promise.resolve()
      }
      this.fetchItemSubcategories({
        disposal_category_codes: this.conditions.disposal_category_codes,
        disable_pagination: true,
      }).then((content) => {
        this.afterDisposalItemSubcategories = content.after_disposal_items || []
      })
    },

		search() {
			if (this.onlyMethod || (!this.onlyFlow && this.isMethod)) {
				this.searchMethods();
			} else {
				this.searchFlows();
			}
		},

		buildCondition(limit) {
			return {
				pattern_name: this.conditions.pattern_name,
				disposer_id: this.conditions.disposer_id,
        disposer_location_id: this.conditions.disposer_location_id,
        disposer_location_code: this.conditions.disposer_location_code,
        disposal_category_codes: this.conditions.disposal_category_codes,
        disposal_subcategory_ids: this.conditions.disposal_subcategory_ids,
				recycle_disposal_method_name: this.conditions.recycle_disposal_method_name,
				after_disposal_method_ids: this.conditions.after_disposal_method_ids,
				without_invisible: this.conditions.without_invisible,
				...this.effectiveFixedCondition,
        own_disposer: this.ownDisposer,
				final_disposal: this.finalDisposal,
				limit: limit,
			};
		},

		searchMethods() {
			this.loading = true;
			const condition = this.buildCondition(this.methodPerPage);
			this.fetchMethods({ condition: condition, page: this.methodPage }).then((content) => {
					this.methods = content.recycle_disposer_disposal_methods || [];
					this.methodPagination = content.pagination || { current_page: 1, total_count: 0 };
				})
				.finally(() => {
					this.loading = false;
				});
		},

		searchFlows() {
			this.loading = true;
			const condition = this.buildCondition(this.flowPerPage);
			this.fetchFlows({ condition: condition, page: this.flowPage })
				.then((content) => {
					this.flows = content.recycle_disposal_flows || [];
					this.flowPagination = content.pagination || { current_page: 1, total_count: 0 };
				})
				.finally(() => {
					this.loading = false;
				});
		},

		disposerChangedCallback(object) {
			if (!object) {
				this.conditions.disposer_id = null;
				this.conditions.disposer_location_id = null;
        this.conditions.disposer_location_code = null;
				this.searchButtonClickEvent();
				return;
			}
			this.conditions.disposer_id = object.id;
			this.searchButtonClickEvent();
		},

		disposerLocationChangeCallback(object) {
			if (!object) {
        this.conditions.disposer_location_id = null;
				this.conditions.disposer_location_code = null;
				this.searchButtonClickEvent();
				return;
			}
			this.conditions.disposer_location_id = object.id;
      this.conditions.disposer_location_code = object.code;
			if (this.conditions.disposer_id !== object.parent_id) {
				this.conditions.disposer_id = object.parent_id;
			}
			this.searchButtonClickEvent();
		},

		closeModal() {
			this.enableTraderModal = false;
		},

		chooseTraderCallback(item) {
			this.conditions.disposer_id = item.id;
			this.closeModal();
			this.searchButtonClickEvent();
		},

		rowClickEvent(item, row) {
			this.setSelectedPattern(item);
			row.select(true);
      this.selectableRow = row;
		},

		rowDoubleClickEvent(event, { item }) {
			// dblclick:rowは (event, { item }) を受け取る
			// itemが直接渡される場合も考慮
			// this.rowClickEvent(item || event);
			this.setSelectedPattern(item || event);
			this.registerButtonClickEvent();
		},

		setSelectedPattern(item) {
			this.selectedPattern = {
				id: item.id,
				type: this.selectedRowType,
				code: item.code,
				pattern_name: item.pattern_name,
			};
		},

		isSelectedRow(item) {
			return !!this.selectedPattern
				&& this.selectedPattern.id === item.id
				&& this.selectedPattern.type === this.selectedRowType;
		},

		initializeAfterRecycleMethods() {
			this.fetchAfterRecycleMethods().then((content) => {
				this.afterRecycleMethods = content.after_recycle_methods;
			});
		},
		rowClass(item) {
			return this.isSelectedRow(item) ? "selected-pattern-row" : "";
		},

		getDetailRows(item) {
			if (this.onlyMethod || (!this.onlyFlow && this.isMethod)) {
				return item.recycle_disposer_disposal_method_details || [];
			}
			return item.recycle_disposal_flow_details || [];
		},

    categoryClick(item) {

      if (this.conditions.disposal_category_codes.includes(item.value)) {
        this.conditions.disposal_category_codes = this.conditions.disposal_category_codes.filter(v => v !== item.value)
      } else {
        this.conditions.disposal_category_codes.push(item.value)
      }
      this.afterDisposalItemCategoryChange();
    },
    subcategoryClick (item) {
      if (this.conditions.disposal_subcategory_ids.includes(item.value)) {
        this.conditions.disposal_subcategory_ids = this.conditions.disposal_subcategory_ids.filter(v => v !== item.value)
      } else {
        this.conditions.disposal_subcategory_ids.push(item.value)
      }
      this.searchButtonClickEvent()
    },

    isCategorySelected(item) {
      return Array.isArray(this.conditions.disposal_category_codes)
        && this.conditions.disposal_category_codes.includes(item.value)
    },

    isSubSelected(item) {
      return Array.isArray(this.conditions.disposal_subcategory_ids)
        && this.conditions.disposal_subcategory_ids.includes(item.value)
    },

    afterDisposalItemCategoryChange () {
      this.loadDisposedTypeOptions()
      this.searchButtonClickEvent()
    },

    clearAfterDisposalItemSubCategories() {
      this.conditions.disposal_subcategory_ids = []
      this.searchButtonClickEvent()
    },
	},
	mounted() {
		this.initializeAfterRecycleMethods();
	}
};
</script>

<template>
	<v-dialog
		:value="enable"
		persistent
		scrollable
		width="1360"
		@keydown.esc="closeButtonClickEvent"
		@close="closeButtonClickEvent"
	>
		<v-card flat>
			<v-toolbar flat>
				<v-toolbar-title>{{ dialogTitle }}</v-toolbar-title>
			</v-toolbar>
			<v-divider />
      <template v-if="false">
        {{ fixedCondition }}
        <br />
        {{ conditions }}
      </template>
			<v-card-text>
				<v-expansion-panels v-model="searchPanel" accordion class="my-4">
					<v-expansion-panel>
						<v-expansion-panel-header class="panel-header-color panel-selectable">
							<strong>
								<v-icon class="panel-header-color">
									mdi-magnify
								</v-icon>
								&nbsp;条件を指定して検索
							</strong>
						</v-expansion-panel-header>
						<v-expansion-panel-content>
							<v-card flat>
								<v-card-text>
									<v-row>
										<v-col cols="12" md="4">
											<v-text-field
												v-model="conditions.pattern_name"
												label="パターン名"
												dense
												hide-details="auto"
												clearable
												outlined
												rounded
												persistent-placeholder
												@change="patternNameChangedCallback"
											/>
										</v-col>
										<v-col cols="12" md="4">
											<infinite-recycle-disposer-auto-complete
												:disposer-id="conditions.disposer_id"
												:location-id="conditions.disposer_location_id"
												:disabled="isDisposerConditionFixed"
                        :own-disposer="ownDisposer"
                        classes="search-font"
                        rounded
												with-none-reporting
												with-none-subscribe
												without-invisible
												@update:values="disposerChangedCallback"
											>
												<template v-slot:append-outer>
													<v-btn
														color="primary"
														:disabled="isDisposerConditionFixed"
														@click="openChooseTraderModalClickEvent"
													>
														選択
													</v-btn>
												</template>
												<template v-slot:item="{ item }">
													<v-chip
														color="#e0ffff"
														drak
														label
														small
													>
														{{ item.type === "Trader::FinalDisposer" ? item.code : item.subscriber_number }}
													</v-chip>&nbsp;
													{{ item.text }}&nbsp;
												</template>
											</infinite-recycle-disposer-auto-complete>
										</v-col>

										<v-col cols="12" md="4">
											<infinite-trader-location-auto-complete
												:trader-id="conditions.disposer_id"
												:location-id="conditions.disposer_location_id"
												:disabled="isDisposerConditionFixed"
                        :own-disposer="ownDisposer"
                        classes="search-font"
												label="処分事業場"
                        chose-one
												rounded
												search-type="trader"
												with-final-disposer
												without-invisible
                        permit-number-registered-only
												@update:values="disposerLocationChangeCallback"
											>
												<template v-slot:item="{ item }">
													<v-chip
														color="#e0ffff"
														drak
														label
														small
													>
														{{ item.code }}
													</v-chip>&nbsp;
													{{ item.text }}&nbsp;
												</template>
											</infinite-trader-location-auto-complete>
										</v-col>
                  </v-row>
                  <v-row>
										<v-col cols="12" md="3">
											<v-text-field
												v-model="conditions.recycle_disposal_method_name"
												label="処分方法名"
												dense
												hide-details="auto"
												clearable
												outlined
												rounded
												persistent-placeholder
												@change="recycleDisposalMethodNameChangedCallback"
											/>
										</v-col>

										<v-col cols="12" md="3">
											<v-autocomplete
												v-model="conditions.after_disposal_method_ids"
												:items="afterRecycleMethods"
												label="処分方法"
												dense
												hide-details="auto"
												clearable
												outlined
												rounded
												multiple
												persistent-placeholder
												@change="afterDisposalMethodIdsChangedCallback"
											/>
										</v-col>

										<v-col cols="12" md="3">
                      <v-select
                        v-model="conditions.disposal_category_codes"
                        :items="afterDisposalItemCategories"
                        class="search-font"
                        clearable
                        dense
                        item-text="text"
                        item-value="value"
                        label="処理後物の大分類名称"
                        multiple
                        hide-details="auto"
                        persistent-placeholder
                        rounded
                        outlined
                        @change="afterDisposalItemCategoryChange"
                      >
                        <template v-slot:item="{ item, on, attrs }">
                          <v-list-item
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-list-item-action
                            >
                              <v-simple-checkbox
                                :value="isCategorySelected(item)"
                                :input-value="isCategorySelected(item)"
                                @click="categoryClick(item)"
                              />
                            </v-list-item-action>
                            <v-list-item-content>
                              <v-list-item-title>
                                <v-chip
                                  small
                                  :color="item.after_type === 'after_industrial' ? 'light-blue lighten-4' : 'light-green lighten-4'"
                                >
                                  {{ item.after_type === 'after_industrial' ? '廃棄物' : '再資源' }}
                                </v-chip>
                                <span class="ml-3">{{ item.text }}</span>
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </template>

                      </v-select>
										</v-col>

										<v-col cols="12" md="3">
                      <v-select
                        v-model="conditions.disposal_subcategory_ids"
                        :items="afterDisposalItemSubcategories"
                        class="search-font"
                        clearable
                        dense
                        item-text="text"
                        item-value="value"
                        label="処理後物の種類"
                        multiple
                        hide-details="auto"
                        persistent-placeholder
                        rounded
                        outlined
                        @change="searchButtonClickEvent"
                        @click:clear="clearAfterDisposalItemSubCategories"
                      >
                        <template v-slot:item="{ item, on, attrs }">
                          <v-list-item
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-list-item-action
                            >
                              <v-simple-checkbox
                                :value="isSubSelected(item)"
                                :input-value="isSubSelected(item)"
                                @click="subcategoryClick(item)"
                              />
                            </v-list-item-action>
                            <v-list-item-content>
                              <v-list-item-title>
                                {{ item.code }}:{{ item.text }}
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-select>
										</v-col>

									</v-row>
								</v-card-text>
								<v-card-actions>
									<v-spacer />
									<v-btn color="primary" @click="searchButtonClickEvent">
										<v-icon>mdi-magnify</v-icon>&nbsp;検索
									</v-btn>
								</v-card-actions>
							</v-card>
						</v-expansion-panel-content>
					</v-expansion-panel>
				</v-expansion-panels>
				<v-row class="mb-2" align="center">
					<v-col cols="12" md="8">
						<v-btn-toggle
              v-if="!onlyMethod && !onlyFlow"
							v-model="conditions.selectable_menu"
              class="toggleButton"
              color="info accent-3"
              tile
              light
              mandatory
              rounded
							@change="menuChangeEvent"
						>
							<v-btn
                value="method"
                width="150"
              >
								処分場処理方法
							</v-btn>
							<v-btn
                value="flow"
                width="150"
              >
								処理フロー
							</v-btn>
						</v-btn-toggle>
					</v-col>
				</v-row>

				<v-data-table
					:headers="listHeaders"
					:items="displayedItems"
					:item-class="rowClass"
					:loading="loading"
					:items-per-page="-1"
					disable-sort
					hide-default-footer
					single-select
					class="pattern-list-table"
					@dblclick:row="rowDoubleClickEvent"
					@click:row="rowClickEvent"
				>
          <!-- パターンコード／パターン名／処分前廃棄物種類 -->
          <template v-slot:[`item.pattern_name`]="{ item }">
						<div style="height: 100%; vertical-align: top">
							<div>{{ item.code }}</div>
							<div class="line-clamp one-clamp">{{ item.pattern_name }}</div>
							<div v-if="item.item_name">
								<v-chip
									color="#F0E6D0"
									drak
									label
									x-small
									class="chip-ellipsis mb-1"
								>
									{{ item.item_name }}
								</v-chip>
								<small><span v-if="item.item_name_count > 0">&emsp;全&nbsp;{{ item.item_name_count }}件</span></small>
							</div>
						</div>
					</template>
          <!-- /パターンコード／パターン名／処分前廃棄物種類 -->

          <!-- 処分事業者／処分事業場／住所 -->
					<template v-slot:[`item.disposer`]="{ item }">
						<div style="height: 100%; vertical-align: top;">
							<div style="display: flex; align-items: center; gap: 4px;">
								<v-img
									v-if="item.use_station"
									max-height="18"
									max-width="18"
									:src="require(`@/assets/images/DXE_mark.svg`)"
								/>
								<span :title="item.disposer_name" class="line-clamp one-clamp">{{ item.disposer_name }} </span>
							</div>
							<div style="display: flex; align-items: center; gap: 4px;">
								<v-img
									v-if="item.use_station"
									max-height="18"
									max-width="18"
									:src="require(`@/assets/images/DXE_mark.svg`)"
								/>
								<span :title="item.disposer_location_name" class="line-clamp one-clamp">{{ item.disposer_location_name }} </span>
							</div>
							<div class="line-clamp one-clamp">
								<small class="text--disabled">
									{{ item.disposer_location_address }}&nbsp;
								</small>
							</div>
						</div>
					</template>
          <!-- /処分事業者／処分事業場／住所 -->

          <!-- 処分方法／按分割合 -->
					<template v-slot:[`item.before_ratio`]="{ item }">
						<div style="height: 100%; vertical-align: top">
							<div v-for="(value, key) in getDetailRows(item)" :key="`before-${item.id}-${key}`">
								<div class="d-flex align-center">
									<v-chip
										class="justify-center mr-2"
                    :class="levelBackgroundColor(value)"
										x-small
									>
                    {{ `${value.level}`.padStart(2, '0') }}
									</v-chip>
									<span class="line-clamp one-clamp">
										{{ value.before_disposal_ratio }}&#37;&nbsp;
										{{ value.recycle_disposal_method_name }}
									</span>
								</div>
							</div>
						</div>
					</template>
          <!-- /処分方法／按分割合 -->

          <!-- 処理後割合／処理後物の種類 -->
					<template v-slot:[`item.output_type`]="{ item }">
						<div style="height: 100%; vertical-align: top;">
							<div v-for="(value, key) in getDetailRows(item)" :key="`output-${item.id}-${key}`">
								<div class="line-clamp one-clamp">
									{{ value.after_disposal_ratio }}&#37;&nbsp;
									{{ value.recycle_disposed_item_name || ' ' }}&nbsp;
									<small>
										<span class="text--disabled">
											{{ value.after_type_label }}<span v-if="value.final_disposal">(最終)</span>
										</span>
									</small>
								</div>
							</div>
						</div>
					</template>
          <!-- /処理後割合／処理後物の種類 -->

				</v-data-table>

				<v-row class="mt-2">
					<v-col>
						<v-pagination
							v-model="currentPage"
							:length="totalPages"
							:total-visible="7"
							circle
							prev-icon="mdi-menu-left"
							next-icon="mdi-menu-right"
							@input="pageChangeEvent"
						/>
					</v-col>
				</v-row>

			</v-card-text>

			<v-divider />
			<v-card-actions>
				<v-spacer />
				<v-btn @click="closeButtonClickEvent">
					閉じる
				</v-btn>
				<v-btn
					color="primary"
					:disabled="!selectedPattern"
					@click="registerButtonClickEvent"
				>
					反映
				</v-btn>
			</v-card-actions>

			<!-- 処分事業者検索モーダル -->
			<choose-trader-modal
				:enable="enableTraderModal"
				search-type="trader"
				without-invisible
				include-final-disposer
        permit-number-registered-only
				@close="closeModal"
				@selected="chooseTraderCallback"
			/>
		</v-card>
	</v-dialog>
</template>

<style scoped lang="scss">
.pattern-list-table ::v-deep tbody tr {
	cursor: pointer;
}

.pattern-list-table ::v-deep tbody tr.selected-pattern-row {
	background: #e9f5ff;
}

.slide-up-enter-active,
.slide-up-leave-active {
	transition: all 0.22s ease;
}

.slide-up-enter,
.slide-up-leave-to {
	opacity: 0;
	transform: translateY(16px);
}

.primary_level { background-color: #00aad1 !important; color: white !important; }

</style>
